import { createSlice } from '@reduxjs/toolkit';

export interface SearchSliceState {
  open: boolean;
  searchType: string;
}

export enum SearchType {
  ALL = 'ALL',
  TEAM = 'TEAM_NAME',
  LEAGUE = 'LEAGUE_NAME',
}

const initialState: SearchSliceState = {
  open: false,
  searchType: 'ALL',
};

export const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    toggleOpen: (state) => {
      state.open = !state.open;
    },
    updateSearchType: (state, action) => {
      state.searchType = action.payload;
    },
  },
  extraReducers: (builder) => {},
});

export default searchSlice.reducer;

const { toggleOpen, updateSearchType } = searchSlice.actions;
export { toggleOpen, updateSearchType };
